import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { campaignsManager, type ICampaign } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const CAMPAIGN_MODULE = 'campaign';

const searchModule = getSearchModule<ICampaign>(campaignsManager);
const dataObjectModule = getDataObjectsModule<ICampaign>(campaignsManager);

const campaignModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(CAMPAIGN_MODULE, campaignModuleInstance);

export { CAMPAIGN_MODULE };
